"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DataGridHeaderColumn_1 = __importDefault(require("./DataGridHeaderColumn"));
var DataGridHeaderColumnCell_1 = __importDefault(require("./DataGridHeaderColumnCell"));
var props_1 = require("../context/props");
var DataGridHeader = function (props) {
    var _a;
    var _b = props.column, infoComponent = _b.infoComponent, LabelComponent = _b.labelComponent, FilterComponent = _b.filterComponent;
    var classes = (0, props_1.usePropsContext)().classes;
    return (react_1.default.createElement("div", { className: ((_a = classes === null || classes === void 0 ? void 0 : classes.cell) === null || _a === void 0 ? void 0 : _a.root) || '' },
        LabelComponent && react_1.default.createElement(LabelComponent, __assign({}, props)),
        !LabelComponent && (infoComponent
            ? react_1.default.createElement(DataGridHeaderColumn_1.default, __assign({}, props))
            : react_1.default.createElement(DataGridHeaderColumnCell_1.default, __assign({}, props))),
        FilterComponent && react_1.default.createElement(FilterComponent, __assign({}, props))));
};
exports.default = DataGridHeader;
